import { useEffect, useState } from 'react';
import { fijarTema, temaGuardado, type Tema } from '../lib/tema';
import { Autoria, GrupoOpciones, Marca, Tarjeta } from '../ui/base';
import { instalacion } from '@tanteo/compartido/instalacion';

const TEMAS: { valor: Tema; etiqueta: string; icono: string }[] = [
  { valor: 'oscuro', etiqueta: 'Oscuro', icono: '☾' },
  { valor: 'claro', etiqueta: 'Claro', icono: '☀' },
  { valor: 'sistema', etiqueta: 'Sistema', icono: '🖥' },
];

/** Preferencias de la aplicación en este dispositivo. Lo del negocio vive en Configuración. */
export function Preferencias() {
  const [tema, setTema] = useState<Tema>(() => temaGuardado());

  // La elección puede haber cambiado en otra pestaña del mismo navegador.
  useEffect(() => setTema(temaGuardado()), []);

  function elegir(nuevo: Tema) {
    fijarTema(nuevo);
    setTema(nuevo);
  }

  return (
    <div className="space-y-6">
      <h1 className="text-titulo font-extrabold">Preferencias</h1>

      <section className="space-y-2">
        <h2 className="text-muted text-etiqueta font-bold uppercase tracking-wide">Tema</h2>
        <GrupoOpciones
          etiqueta="Tema de la interfaz"
          valor={tema}
          onElegir={elegir}
          opciones={TEMAS.map((t) => ({ valor: t.valor, texto: t.etiqueta, icono: t.icono, e2e: `tema-${t.valor}` }))}
        />
        <p className="text-muted text-contenido">
          «Sistema» sigue la preferencia de tu equipo y cambia con ella. La elección es de este
          dispositivo, no de tu cuenta.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-muted text-etiqueta font-bold uppercase tracking-wide">Acerca de</h2>
        <Tarjeta>
          <div className="mb-3 flex items-center gap-3">
            <Marca className="text-marca" />
            <p className="text-muted text-contenido">Ventas, cuadre de caja y gastos para tu negocio</p>
          </div>
          <div className="border-border space-y-1 border-t pt-3 text-contenido">
            <Fila etiqueta="Versión" valor={VERSION} />
            <Fila etiqueta="Tecnología" valor="React · Supabase · Cloudflare" />
          </div>
          <p className="text-muted mt-3 text-etiqueta">© 2026 {instalacion.nombre}. Todos los derechos reservados.</p>
          <Autoria className="mt-3" />
        </Tarjeta>
      </section>
    </div>
  );
}

/** Inyectada por Vite desde la versión del package.json; sin ella el bloque mentiría. */
const VERSION = __VERSION_TANTEO__;

function Fila({ etiqueta, valor }: { etiqueta: string; valor: string }) {
  return (
    <div className="flex justify-between">
      <span className="text-muted">{etiqueta}</span>
      <span className="num">{valor}</span>
    </div>
  );
}
